import React, { useState } from 'react';
import { Field, FieldArray } from 'redux-form';
import { renderDollar, renderFieldDisabled, renderCurrency, renderDollarDisabled, renderCurrencyDisabled } from '../../../../../Utils/renderField/renderField';
import { renderField } from "../../../../../Utils/renderField/renderField"
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { 
    useAnnualTotals, 
    CurrencyDisplay, 
    isSalidaRow, 
    getCellStyles
} from './CashFlowComponentsAnnual';
import './CashFlow.css';


// Componente para mostrar valores calculados localmente
const LocalCurrencyDisplay = ({ value, currency, isSalida, isTotal = false }) => {
    if (value === null || value === undefined || isNaN(value)) {
        return <span>-</span>;
    }
    
    return <CurrencyDisplay 
        value={value} 
        currency={currency} 
        isSalida={isSalida} 
    />;
};

const TableRow = ({ system, index, fields, change, currency, year_list, localTotals }) => {

    const is_manual = fields.get(index).is_manual;
    const isTitulo = fields.get(index).isTitulo;
    const currentRow = fields.get(index);
    const isSalida = isSalidaRow(currentRow);
    const isFinal = fields.get(index).isFinal
    const isOpeningBalance = fields.get(index).isOpeningBalance

    React.useEffect(() => {
        change(`${system}.is_dollar`, currency === 'USD');
    }, [currency, system, change]);

    // Obtener valores calculados localmente para las filas del resumen
    const getLocalValue = (year) => {
        if (!localTotals) return 0;
        
        // Mapear indices del resumen con los totales locales
        switch (index) {
            case 1: // ENTRADAS
                return localTotals.entradas[year] || 0;
            case 2: // SALIDAS  
                return localTotals.salidas[year] || 0;
            case 3: // FLUJO NETO
                return localTotals.flujoNeto[year] || 0;
            case 4: // SALDO FINAL
                return localTotals.saldoFinal[year] || 0;
            default:
                return parseFloat(currentRow[year]) || 0;
        }
    };

    const cellStyle = getCellStyles(isSalida, isFinal);
    const disabledStyle = isSalida ? { color: '#dc3545', fontWeight: '500' } : { fontWeight: '500' }


    return (
        <React.Fragment key={index}>
            <tr key={`system-${index}`}>
                <td className='first-column table-form-fixed-cell-left-0' style={!isFinal ? { minWidth: "200px" } : { backgroundColor: "#F0FFC7", minWidth: "200px" }} >
                    <Field
                        name={`${system}.name`}
                        type="text"
                        isTextarea={!isTitulo}
                        applyStyles={!isTitulo}
                        style={disabledStyle}
                        component={is_manual ? renderField : renderFieldDisabled}
                        className="form-control"
                        placeholder='Nuevo'
                    />
                </td>
                {!isOpeningBalance ?
                    year_list.map((year) => (
                        <td key={year} style={!isFinal ? { width: "6.9%" } : { width: "6.9%", backgroundColor: "#F0FFC7" }}>
                            {/* Para filas del resumen (1-4), mostrar valores calculados */}
                            {localTotals && index >= 1 && index <= 4 ? (
                                <div style={{ 
                                    textAlign: 'right', 
                                    padding: '6px 12px',
                                    color: isSalida ? '#dc3545' : '',
                                    fontWeight: '500'
                                }}>
                                    <LocalCurrencyDisplay 
                                        value={getLocalValue(year)} 
                                        currency={currency} 
                                        isSalida={isSalida}
                                    />
                                </div>
                            ) : (
                                <Field
                                    name={`${system}.${year}`}
                                    type="text"
                                    component={currency !== 'USD'
                                        ?
                                        is_manual ? renderCurrency : renderCurrencyDisabled
                                        :
                                        is_manual ? renderDollar : renderDollarDisabled
                                    }
                                    disabledStyle={disabledStyle}
                                    className="form-control"
                                    placeholder={fields.get(index).is_dollar ? '$ 0.00' : 'Q 0.00'}
                                />
                            )}
                        </td>
                    ))
                    :
                    <td style={!isFinal ? { width: "6.9%" } : { width: "6.9%", backgroundColor: "#F0FFC7" }}>
                        <Field
                            name={`${system}.${year_list[0]}`}
                            type="text"
                            component={currency !== 'USD' ? renderCurrencyDisabled : renderDollarDisabled}
                            disabledStyle={disabledStyle}
                            className="form-control"
                            placeholder={fields.get(index).is_dollar ? '$ 0.00' : 'Q 0.00'}
                        />
                    </td>
                }
            </tr>
        </React.Fragment>
    );
};

const GenericTable = ({ fields, allValues, change, eliminar, currency, year_list }) => {
   
    // Calcular totales una vez al cargar
    const localTotals = useAnnualTotals(allValues, year_list);
   
    const columnas = year_list.map((year, index) => (
        <th key={index} style={{ width: `${100 / year_list.length}%` }}>{year}</th>
    ));

    return (
        <div className=" col-sm-12 form-group np-r p-0">
            <div className='table-responsive report-scroll-content cash-flow'>
                <table className="table table-striped mb-0">
                    <thead className="thead-not-cursor">
                        <tr>
                            <th className='first-column table-form-fixed-cell-left-0 titulo-left-padded'>AÑO</th>
                            {columnas}
                        </tr>
                    </thead>
                    <tbody style={{ backgroundColor: "#F0FFC7" }}>
                        {fields.map((system, index) => 
                            <TableRow 
                                key={index} 
                                system={system} 
                                index={index} 
                                fields={fields} 
                                change={change} 
                                eliminar={eliminar} 
                                currency={currency} 
                                year_list={year_list}
                                localTotals={localTotals}
                            />
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

const ResumeFlow = ({allValues, change, eliminar, currency, year_list }) => {
    if (!year_list || year_list.length === 0) {
        return <p>Cargando datos...</p>;
    }

    return (
        <div>
            <FieldArray
                name={`summary`}
                component={GenericTable}
                allValues={allValues}
                change={change}
                eliminar={eliminar}
                currency={currency}
                year_list={year_list}
            />
        </div>
    );
}

const formName = 'CashFlowForm';

const selector = formValueSelector(formName);

const mapStateToProps = (state) => {
    // Obtener toda la estructura de datos del formulario
    const allFormValues = {
        operation: selector(state, 'operation') || [],
        financial: selector(state, 'financial') || [],
        investments: selector(state, 'investments') || {},
        summary: selector(state, 'summary') || []
    };
    
    return { allValues: allFormValues };
};

export default connect(mapStateToProps)(ResumeFlow);